<div class="rd-page">

    <!-- Back -->
    <button class="rd-back-btn" (click)="goBack()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Back
    </button>

    <!-- Header -->
    <div class="rd-header">
        <div class="rd-header-left">
            <h2 class="rd-title">
                Ride #{{ rideDetails()?.rideId }}
                <span class="rd-status-badge" [ngClass]="statusBadgeClass(rideDetails()?.status)">
                    • {{ rideDetails()?.status?.replace('_', ' ') | titlecase }}
                </span>
            </h2>
        </div>
        <div class="rd-header-actions">
            <!-- @if (rideDetails()?.status !== 'ACTIVE') {
            <button class="rd-photo-btn" (click)="openImagesCarouselDialog()">
                Parking photo
            </button>
            } -->
            @if (rideDetails()?.status === 'ACTIVE') {
            <button class="rd-end-btn" (click)="openEndRideDialog()">
                <span>✕</span> End Ride
            </button>
            }
        </div>
    </div>

    <!-- Tabs -->
    <div class="rd-tabs">
        <button class="rd-tab" [class.rd-tab--active]="activeTab() === '0'" (click)="onTabChange('0')">General Info</button>
        <button class="rd-tab" [class.rd-tab--active]="activeTab() === '1'" (click)="onTabChange('1')">Billing</button>
        <button class="rd-tab" [class.rd-tab--active]="activeTab() === '2'" (click)="onTabChange('2')">Contracts</button>
    </div>

    <!-- Tab content — use [hidden] so components stay alive and no API re-calls on tab switch -->
    @if (rideDetails()) {
    <div class="rd-tab-content">
        <div [hidden]="activeTab() !== '0'">
            <app-ride-details-general-info [rideDetails]="rideDetails()!" />
        </div>
        <div [hidden]="activeTab() !== '1'">
            <app-ride-details-billings [rideDetails]="rideDetails()!" />
        </div>
        <div [hidden]="activeTab() !== '2'">
            <app-ride-details-contracts [rideDetails]="rideDetails()!" />
        </div>
    </div>
    }

</div>

@defer (when imagesCarouselDialog; prefetch on idle) {
<app-show-images-carousel-dialog [id]="rideDetails()!.rideId" [images]="ridePhotos"
    [(visibility)]="imagesCarouselDialog" (approve)="openApproveEndRidePhotos()"
    (reject)="openRejectEndRidePhotos()"
    [showApprove]="rideDetails()?.endRidePhotos?.status === 'PENDING'"
    [showReject]="rideDetails()?.endRidePhotos?.status === 'PENDING'" />
}

@defer (when approveEndRidePhotosDialog; prefetch on idle) {
<app-approve-end-ride-photos-form [selectedRide]="rideDetails()!"
    (endRidePhotosApproved)="onEndRidePhotosApproved()" [(visibility)]="approveEndRidePhotosDialog" />
}

@defer (when rejectEndRidePhotosDialog; prefetch on idle) {
<app-reject-end-ride-photos-form [selectedRide]="rideDetails()!"
    (endRidePhotosRejected)="onEndRidePhotosApproved()" [(visibility)]="rejectEndRidePhotosDialog" />
}

@defer (when endRideDialog; prefetch on idle) {
<app-end-ride-form [selectedRide]="rideDetails()!" (rideEnded)="onRideEnded()"
    [(visibility)]="endRideDialog" />
}
